import { ReactNode } from "react";
import { PureTooltip } from "components/Tooltip";
import { InformationCircleIcon } from "@heroicons/react/outline";
import { cx } from "utils";
import { Align, alignClass } from "../types";

type HeaderColumn = {
  key: string;
  header: ReactNode;
  tooltip?: string;
  align?: Align;
  thClassName?: string;
};

/** Renders the <thead> + header row, including the optional info-icon tooltip per column. */
export const TableHeader = ({ columns }: { columns: HeaderColumn[] }) => (
  <thead>
    <tr className="bg-[#ecf0f3] border-b border-gray-200">
      {columns.map((col) => (
        <th key={col.key} className={cx("px-6 py-3 text-xs font-medium", alignClass(col.align), col.thClassName)}>
          {col.tooltip ? (
            <div className={cx("flex items-center gap-1", col.align === "right" && "justify-end")}>
              {col.header}
              <PureTooltip content={col.tooltip}>
                <InformationCircleIcon className="w-3.5 h-3.5 text-gray-400" />
              </PureTooltip>
            </div>
          ) : (
            col.header
          )}
        </th>
      ))}
    </tr>
  </thead>
);

export default TableHeader;
